import { Matches, MaxLength, IsOptional, IsNotEmpty, IsEnum } from "class-validator";
import { ApiProperty } from "@nestjs/swagger";

export class EmployeeLeavesDTO{

    @ApiProperty()
    @IsOptional()
    employeeLeavesId: number;

    @ApiProperty()
    @IsOptional()
    employeeId: number;

    @ApiProperty()
    @IsNotEmpty({message: 'Type Of leave should not be empty'})
    year: string;

    @ApiProperty()
    typeOfLeave: number;

    @ApiProperty()
    @IsNotEmpty({message: 'Leave from day should not be empty'})
    leavesAlloted: number;

    @ApiProperty()
    leavesUsed: number;

    @ApiProperty()
    @IsNotEmpty({message: 'Leave To day should not be empty'})
    leavesAvailable: number;

    @ApiProperty()
    dateTime: Date;

    @ApiProperty()
    isActive: boolean;
    createdAt: Date;

    @ApiProperty()
    @IsOptional()
    @MaxLength(40, {message: 'Created user allows maximun 40 characters'})
    @Matches(new RegExp("^(?:[a-zA-Z\\s]|)+$"), {message: 'Created user should contain only characters'})
    createdUser: string;
    
    updatedAt: Date;

    @ApiProperty()
    @IsOptional()
    @MaxLength(40, {message: 'Updated User allows maximum 40 characters'})
    @Matches(new RegExp("^(?:[a-zA-Z\\s]|)+$"), {message: 'Updated user should contain only characters'})
    updatedUser: string;

    @ApiProperty()
    versionFlag: number;

}